<div
  *ngIf="
    hotCatogries?.length && windowWidth < 768
      ? cartProductItems.length || cartRecipeItems.length
      : true
  "
>
  <div class="head">
    <p class="m-0">{{ sideCartHeaderText || "My Cart" }}</p>
    <small
      ><b>{{ _requestService.cartCounter$ | async }}</b> : Items</small
    >
  </div>
  <div
    *ngIf="cartProductItems.length == 0 && cartRecipeItems.length == 0"
    class="bg-white br-10px"
  >
    <h2 class="NoItem">
      {{ emptyCartMessage || "There are no items in the cart" }}
    </h2>
  </div>

  <ng-container
    *ngIf="cartProductItems.length != 0 || cartRecipeItems.length != 0"
  >
    <table class="bg-white">
      <thead>
        <tr>
          <th>item</th>
          <th>quantity</th>
          <th *ngIf="total">price</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let item of cartRecipeItems"
          [ngStyle]="
            (!item.ForCollection &&
              (_requestService.deliveryType$ | async) == 'Store') ||
            (!item.ForDelivery &&
              (_requestService.deliveryType$ | async) == 'Home') ||
            (!item.ForEatIn &&
              (_requestService.deliveryType$ | async) == 'EatIn')
              ? { 'background-color': '#dc354526' }
              : item.isPromotionItem
                ? { 'background-color': '#d1ebd9' }
                : {}
          "
          class="border-bottom"
        >
          <td>
            <div class="produtInfo">
              <p class="maxWidth">
                <b>{{ item?.RecipeTitle }}</b>
              </p>
              <div>
                <small
                  (click)="removeRecipeItem(item)"
                  style="color: red; cursor: pointer"
                  title="Delete Item"
                  ><i class="fa fa-trash hoverTrash" aria-hidden="true"></i
                ></small>
              </div>
            </div>
            <div class="deliveryOrCollection">
              <p
                class="m-0 text-danger"
                *ngIf="
                  !item.ForDelivery &&
                  (_requestService.deliveryType$ | async) == 'Home'
                "
              >
                Not Available For Delivery
              </p>
              <p
                class="m-0 text-danger"
                *ngIf="
                  !item.ForCollection &&
                  (_requestService.deliveryType$ | async) == 'Store'
                "
              >
                Not Available For Collection
              </p>
              <p
                class="m-0 text-danger"
                *ngIf="
                  !item.ForEatIn &&
                  (_requestService.deliveryType$ | async) == 'EatIn'
                "
              >
                Not Available For EatIn
              </p>
            </div>
            <div *ngFor="let extra of item?.RecipeExtraObject; let last = last">
              <div
                class="d-flex justify-content-between"
                style="align-items: center"
              >
                <div>
                  <ng-container
                    *ngIf="
                      extra.RecipeDiscountType && extra.RecipeDiscountAmount
                    "
                  >
                    <small
                      class="text-center rounded-3 px-1"
                      [ngStyle]="{
                        'background-color':
                          ExtraDiscountLabelBGColor || '#198754',
                        color: ExtraDiscountLabelTextColor || '#FFFFFF'
                      }"
                    >
                      <small class="m-0 lh-1">
                        <!-- <i class="fa fa-gift"></i> -->
                        <ng-container
                          *ngIf="extra?.RecipeDiscountType === 'Percentage'"
                        >
                          {{
                            extra?.RecipeDiscountAmount / 100 | percent: "1.0-2"
                          }}
                          OFF
                        </ng-container>
                        <ng-container
                          *ngIf="extra?.RecipeDiscountType === 'Cash'"
                        >
                          {{
                            extra?.RecipeDiscountAmount
                              | currency: CurrencySymbol
                          }}
                          OFF
                        </ng-container>
                      </small>
                    </small>
                  </ng-container>
                  <div class="d-flex">
                    <p class="ps-1 m-0 fs11px" *ngIf="extra.Quantity > 1">
                      {{ extra?.Quantity }}
                    </p>
                    <p
                      class="ps-1 text-center m-0 fs11px"
                      *ngIf="extra.Quantity > 1"
                    >
                      X
                    </p>
                    <p class="ps-1 m-0 fs11px">
                      {{ extra?.Title }}
                    </p>
                  </div>
                </div>
                <p
                  class="ps-1 text-end m-0 fs11px"
                  *ngIf="extra.RecipeDiscountAmount ? true : extra.Price > 0"
                >
                  <small
                    [ngStyle]="{ color: RecipeOldPriceTextColor }"
                    *ngIf="
                      extra.RecipeDiscountType
                        ? true
                        : extra.RecipeDiscountType && extra?.RecipeOldPrice
                    "
                    class="d-block"
                  >
                    <s>{{
                      extra?.RecipeOldPrice | currency: CurrencySymbol
                    }}</s>
                  </small>
                  {{
                    extra?.Price | currency: CurrencySymbol : "symbol" : "1.2-2"
                  }}
                </p>
              </div>
              <hr class="m-1" *ngIf="!last" />
            </div>
          </td>
          <td>
            <div
              class="QuantityContainer"
              *ngIf="item.isPromotionItem !== true"
            >
              <button
                class="prev"
                (click)="
                  !item?.socialDiscountItem ? cartRecipeUpdation('-', item) : ''
                "
              >
                <i class="fas fa-minus"></i>
              </button>
              <span class="quntitySpan" style="font-weight: bold">{{
                item?.RecipeQuantity
              }}</span>
              <button
                (click)="
                  !item?.socialDiscountItem ? cartRecipeUpdation('+', item) : ''
                "
                [disabled]="item.RecipeMaxBuyAllowed == item.RecipeQuantity"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </td>
          <td class="alignTextCenter">
            <ng-container
              *ngIf="item.RecipeDiscountType && item.RecipeDiscountAmount"
            >
              <div
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <small
                  class="text-center rounded-3 px-1"
                  [ngStyle]="{
                    'background-color': RecipeDiscountLabelBGColor || '#198754',
                    color: RecipeDiscountLabelTextColor || '#FFFFFF'
                  }"
                >
                  <small class="m-0 lh-1">
                    <!-- <i class="fa fa-gift"></i> -->
                    <ng-container
                      *ngIf="item?.RecipeDiscountType === 'Percentage'"
                    >
                      {{ item?.RecipeDiscountAmount / 100 | percent: "1.0-2" }}
                      OFF
                    </ng-container>
                    <ng-container *ngIf="item?.RecipeDiscountType === 'Cash'">
                      {{
                        item?.RecipeDiscountAmount | currency: CurrencySymbol
                      }}
                      OFF
                    </ng-container>
                  </small>
                </small>

                <small
                  [ngStyle]="{ color: RecipeOldPriceTextColor }"
                  *ngIf="
                    item.RecipeDiscountType
                      ? true
                      : item.RecipeDiscountType && item?.RecipeOldPrice
                  "
                >
                  <s>{{ item?.RecipeOldPrice | currency: CurrencySymbol }}</s>
                </small>
              </div>
            </ng-container>
            {{
              item?.recipeTotal | currency: CurrencySymbol : "symbol" : "1.2-2"
            }}
          </td>
        </tr>

        <tr *ngFor="let item of cartProductItems">
          <td class="w-55">
            <div class="produtInfo">
              <p class="maxWidth">{{ item?.ProductTitle }}</p>
              <div>
                <small
                  (click)="removeProductItem(item)"
                  style="color: red; cursor: pointer"
                  title="Delete Item"
                  ><i class="fa fa-trash hoverTrash" aria-hidden="true"></i
                ></small>
              </div>
            </div>
            <div class="deliveryOrCollection">
              <p
                class="m-0 text-danger"
                *ngIf="
                  !item.ForDelivery &&
                  (_requestService.deliveryType$ | async) == 'Home'
                "
              >
                Not Available For Delivery
              </p>
              <p
                class="m-0 text-danger"
                *ngIf="
                  !item.ForCollection &&
                  (_requestService.deliveryType$ | async) == 'Store'
                "
              >
                Not Available For Collection
              </p>
            </div>
            <div *ngFor="let extra of item?.ProductExtraObject">
              <div class="d-flex justify-content-between">
                <div class="d-flex">
                  <p class="p-1 m-0 fs11px" *ngIf="extra.Quantity > 1">
                    {{ extra?.Quantity }}
                  </p>
                  <p
                    class="p-1 text-center m-0 fs11px"
                    *ngIf="extra.Quantity > 1"
                  >
                    X
                  </p>
                  <p class="p-1 m-0 fs11px">{{ extra?.Title }}</p>
                </div>
                <p class="p-1 text-end m-0 fs11px" *ngIf="extra.Price > 0">
                  {{
                    extra?.Price | currency: CurrencySymbol : "symbol" : "1.2-2"
                  }}
                </p>
              </div>
            </div>
          </td>
          <td class="w-30">
            <div
              class="QuantityContainer"
              *ngIf="
                PopupOnKgItems
                  ? !(item.ProductUnits.toLowerCase() == 'kg')
                  : true
              "
            >
              <span
                class="prev"
                (click)="
                  !item?.socialDiscountItem
                    ? cartProductUpdation('-', item)
                    : ''
                "
              >
                <i class="fas fa-minus"></i
              ></span>
              <span class="quntitySpan" style="font-weight: bold">{{
                item?.ProductQuantity
              }}</span>
              <span
                class="next"
                (click)="
                  !item?.socialDiscountItem
                    ? cartProductUpdation('+', item)
                    : ''
                "
                ><i class="fas fa-plus"></i
              ></span>
            </div>
            <div
              *ngIf="
                PopupOnKgItems ? item.ProductUnits.toLowerCase() == 'kg' : false
              "
            >
              <select
                name="kgList"
                id="kgList"
                class="form-select kgList"
                (change)="kgListChanged(item)"
                [disabled]="item?.socialDiscountItem"
                [(ngModel)]="item.ProductQuantity"
              >
                <option value="0.5">0.5kg</option>
                <option value="1.0">1.0kg</option>
                <option value="1.5">1.5kg</option>
                <option value="2.0">2.0kg</option>
                <option value="2.5">2.5kg</option>
                <option value="3.0">3.0kg</option>
              </select>
            </div>
          </td>
          <td class="alignTextCenter w-20" *ngIf="item?.ProductTotal">
            {{
              item?.ProductTotal | currency: CurrencySymbol : "symbol" : "1.2-2"
            }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="total" *ngIf="total">
      <p class="m-0">{{ epos ? "Sub Total" : "Total" }}</p>
      <p class="m-0 text-danger">
        {{ total | currency: CurrencySymbol : "symbol" : "1.2-2" }}
      </p>
    </div>
  </ng-container>

  <ng-container
    *ngIf="
      promotionItemsSettings?.Enabled && showPromotions && !epos && (promotionsItems$ | async) as promotions
    "
  >
    <div class="row mt-1">
      <div class="col-12">
        <ng-container *ngFor="let promotion of promotions">
          <div
            class="rounded-3 bg-white mb-1"
            style="border: 2px solid #57cc7c"
            *ngIf="
              !promotion.RecipeDetails.isLocked &&
              !promotion.RecipeDetails.isAddedToCart
            "
          >
            <div class="p-2 rounded-3" style="background-color: #f0fdf4">
              <span class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <span
                    style="min-width: 50px; width: 50px"
                    *ngIf="promotion.RecipeDetails.RecipeImage"
                  >
                    <img
                      [src]="promotion.RecipeDetails.RecipeImage"
                      alt="Recipe Image"
                      class="w-100 rounded-3"
                    />
                  </span>
                  <span class="ms-2">
                    <p
                      class="fw-bold mb-1 text-muted"
                      style="font-size: 0.8rem"
                    >
                      Free {{ promotion.RecipeDetails.RecipeTitle }}
                      <button
                        class="btn btn-sm rounded-pill ms-2 fw-bold"
                        disabled
                        style="
                          border: 1px solid #57cc7c;
                          background-color: #f0fdf4;
                          color: #57cc7c;
                          font-size: 0.7rem;
                        "
                      >
                        UNLOCKED
                      </button>
                    </p>
                    <p
                      class="text-muted m-0 text-muted"
                      style="font-size: 0.7rem"
                    >
                      You've unlocked free items. Choose your free item
                    </p>
                  </span>
                </div>
                <button
                  class="btn btn-sm bg-white rounded-3 ms-1"
                  type="button"
                  style="
                    border: 1px solid #57cc7c;
                    color: #57cc7c;
                    font-size: 0.7rem;
                    min-width: 75px;
                  "
                  (click)="callCheckout()"
                >
                  Check Item
                </button>
              </span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let promotion of promotions">
          <div
            class="rounded-3 mb-1 bg-white"
            style="border: 2px dashed #cacaca"
            *ngIf="promotion.RecipeDetails.isLocked"
          >
            <div class="p-2 rounded-3" style="background-color: #fbfbfb">
              <span class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <span
                    style="width: 50px"
                    *ngIf="promotion.RecipeDetails.RecipeImage"
                  >
                    <img
                      [src]="promotion.RecipeDetails.RecipeImage"
                      alt="Recipe Image"
                      class="w-100 rounded-3"
                    />
                  </span>
                  <span class="ms-2">
                    <p
                      class="fw-bold mb-1 text-muted"
                      style="font-size: 0.8rem"
                    >
                      Free {{ promotion.RecipeDetails.RecipeTitle }}
                    </p>
                    <p
                      class="text-muted m-0 text-muted"
                      style="font-size: 0.7rem"
                    >
                      Unlocks at
                      {{
                        promotion.MinOrderAmount
                          | currency: CurrencySymbol : "symbol" : "1.2-2"
                      }}
                    </p>
                  </span>
                </div>

                <button
                  class="btn btn-sm btn-outline-secondary rounded-pill"
                  disabled
                >
                  LOCKED
                </button>
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-container
    *ngIf="cartProductItems.length != 0 || cartRecipeItems.length != 0"
  >
    <button
      *ngIf="!stopOnlineOrdersMessage && !epos"
      [disabled]="cartRecipeItems.length == 0 && cartProductItems.length == 0"
      (click)="callCheckout()"
      class="checkout-btn w-100"
      [ngStyle]="{
        'background-color': SelectedButtonColor,
        color: SelectedButtonTextColor,
        'border-radius': buttonRadius
      }"
    >
      {{ sideCartButtonText ? sideCartButtonText : "Checkout" }}
    </button>
    <div
      *ngIf="stopOnlineOrdersMessage"
      class="p-2 rounded-3 mt-3"
      [ngStyle]="{
        border: '1px solid ' + stopOnlineOrdersMessage?.border,
        background: stopOnlineOrdersMessage?.BGColor
      }"
    >
      <h2
        class="text-center m-0"
        [ngStyle]="{ color: stopOnlineOrdersMessage?.TextColor }"
      >
        {{ stopOnlineOrdersMessage?.Message }}
      </h2>
    </div>
  </ng-container>
</div>
